import { z } from 'zod';
/**
 * KRW (대한민국 원) 금액 표현을 위한 브랜드 타입.
 *
 * 정책 (PROJECT.md Core Value, PITFALLS §P1 대차 무결성):
 * - KRW 는 정수 원 단위만 허용 — 소수점 원은 대한민국 실무에 존재하지 않음.
 * - 음수 금지 — 환불·수수료 차감은 ledger entry 의 `side`(debit/credit) 로 표현.
 * - 상한 Number.MAX_SAFE_INTEGER (≈ 9.007e15 원) — 그 이상은 BigInt 로 승급
 *   (Wave 4+ 글로벌 확장 시 재평가).
 *
 * `KrwAmount` 브랜드 타입은 plain `number` 와 컴파일타임에 서로 대입 불가하여,
 * 다른 통화·단위(센트·USD 등)와 혼용되는 실수를 차단한다.
 */
export const krwAmountSchema = z
    .number()
    .finite()
    .int()
    .nonnegative()
    .max(Number.MAX_SAFE_INTEGER)
    .brand();
/**
 * 생성 헬퍼 — 런타임 검증 후 브랜드된 값을 반환.
 * 검증 실패 시 `ZodError` throw.
 *
 * 사용 예:
 *   const amount = krwAmount(5000); // OK
 *   const bad = krwAmount(-1);      // throws
 */
export const krwAmount = (n) => krwAmountSchema.parse(n);
//# sourceMappingURL=money.js.map